import { render, staticRenderFns } from "./customerinvoice.vue?vue&type=template&id=1f86e3eb&scoped=true&"
import script from "./customerinvoice.vue?vue&type=script&lang=js&"
export * from "./customerinvoice.vue?vue&type=script&lang=js&"
import style0 from "./customerinvoice.vue?vue&type=style&index=0&id=1f86e3eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f86e3eb",
  null
  
)

export default component.exports